export default {"src":"/_next/static/media/bab.25e96cd7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};